import { render, staticRenderFns } from "./baseline-layout.vue?vue&type=template&id=2d08fc21&scoped=true"
import script from "./baseline-layout.vue?vue&type=script&lang=ts"
export * from "./baseline-layout.vue?vue&type=script&lang=ts"
import style0 from "./baseline-layout.vue?vue&type=style&index=0&id=2d08fc21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08fc21",
  null
  
)

export default component.exports